const aboutTR = {
  seo: {
    title: "Hakkimizda | QuadroCode",
    description:
      "QuadroCode, aile vizyonu, mentorluk ve uzun vadeli teknik gelisim uzerine kurulu bir yazilim sirketidir.",
  },
  hero: {
    eyebrow: "QuadroCode Hakkinda",
    title: "Gelecegi Nesilden Nesile Insa Ediyoruz",
    lead:
      "QuadroCode bir yazilim gelistirme sirketinden daha fazlasidir. Vizyon, sorumluluk ve guclu yazilimcilarin erken donemde gercek uretimle yetistigine dair inanc uzerine kurulu uzun vadeli bir misyondur.",
  },
  story: {
    eyebrow: "QuadroCode'un Hikayesi",
    title: "Aile fikrinden gercek bir yazilim sirketine",
    paragraphs: [
      "Quadro adi, sirketin kurulmasina ilham veren dort cocugu temsil eder. Programlama becerilerini desteklemek icin baslayan sade bir fikir, zamanla daha buyuk bir amaca donustu: pratik teknoloji, faydali urunler ve surdurulebilir dijital isler gelistirmek.",
      "Bugun dort cocuktan ikisi sirkette aktif rol aliyor. Biri backend gelistirme ve sistem mantigina odaklaniyor. Digeri frontend gelistirme ve kullanici deneyimi uzerinde calisiyor. Sadece kod yazmayi ogrenmiyorlar; teknolojideki gelecekteki rollerinin profesyonel temelini insa ediyorlar.",
    ],
  },
  vision: {
    eyebrow: "Aile Vizyonu",
    title: "QuadroCode neden var",
    quote: "Erken kazanilan beceriler zamanla ustaliga donusur.",
    paragraphs: [
      "QuadroCode yalnizca teknik bilgi ogretmek icin kurulmadi. Amac, teknolojinin gercek dunyada nasil deger uretecegini anlayan disiplinli problem cozuculer, ureticiler ve girisimciler yetistirmektir.",
      "Sirket uzun vadeli sureklilik anlayisiyla yapilandirildi. Kucuk iki cocuk da buyuyup 15 yasina geldiginde, kendi yetenekleri ve bakis acilariyla bu yolculuga katilacak.",
    ],
  },
  mentorship: {
    eyebrow: "Deneyimden Mentorluk",
    title: "One cikmadan yol gosteren liderlik",
    paragraphs: [
      "Bu yolculugun arkasinda onlarca yillik teknoloji deneyimine sahip bir baba var. Programlama yolculugu 1992 yilinda Assembly, C ve C++ ile basladi; o donemde sistem duzeyi dusunce ve yuksek hassasiyet esasti.",
      "Yillar icinde bu temel, platformlar, yazilim sistemleri ve teknoloji isleri kurmaya evrildi. Bugun bir fintech sirketinin lideri olarak yazilim mimarisi, muhendislik sureci ve stratejik uygulama alanlarinda derin deneyim sunuyor.",
      "QuadroCode'da bu birikim yeni nesle aktariliyor. Rolun odagi, gunluk kodlamayi yonetmek degil; genc gelistiricilerin anlamli yazilimlar uretmesi icin teknik disiplin ve urun dusuncesini gelistirecek mentorluk sunmaktir.",
    ],
  },
  learning: {
    eyebrow: "Yaparak Ogrenme",
    title: "Gercek projeler, gercek standartlar, gercek gelisim",
    bullets: ["Gercek seyler insa et.", "Gercek problemler coz.", "Gercek yazilim teslim et."],
    paragraphs: [
      "QuadroCode'da ogrenme yalnizca teoriye dayanmaz. Web sitelerinden dijital platformlara ve ozel yazilim cozumlerine kadar her proje hem musteriye teslim edilen bir urun hem de uzun vadeli teknik gelisim icin bir egitim alanidir.",
      "Bu yaklasimla inovasyon ve egitim birlikte ilerler; kalite ise ilk gunden itibaren profesyonel bir standart olarak ele alinir.",
    ],
  },
  future: {
    eyebrow: "Bugun ve Gelecek Vizyonu",
    title: "Bugun icin kuruldu, nesiller icin tasarlandi",
    paragraphs: [
      "QuadroCode bugun odakli ve iddiali bir yazilim sirketidir. Uzun vadeli hedef, genc yaraticilik ile deneyimli muhendislik liderligini birlestiren aile odakli bir teknoloji studyosuna donusmektir.",
      "Zamanla dort cocugun tamami aktif katkida bulundugunda, QuadroCode adi tam anlamiyla gerceklige donusecek: gelecegi birlikte insa eden dort zihin.",
    ],
    missionTitle: "Misyonumuz",
    missionText:
      "Bir sonraki teknoloji ureticisi nesli yetistirirken pratik ve guvenilir yazilim cozumleri uretmek. Cunku gelecege hazirlanmanin en iyi yolu, onu bugunden insa etmektir.",
  },
  cta: {
    eyebrow: "Iletisimi baslatalim",
    title: "Uzun vadeli amacla yazilim ureten bir ekiple calisin",
    text:
      "Net vizyonu ve ciddi muhendislik yaklasimi olan bir yazilim ortagi ariyorsaniz, QuadroCode is birligi icin hazir.",
    primary: "Projenizi Konusalim",
    secondary: "Hizmetleri Kesfedin",
  },
};

export default aboutTR;
